import api from "api/axios";

export const fetchCategoriesTree = (payload) =>
  api.post("/product-categories/search", payload);

export const fetchOrganizerCategories = (companyId) =>
  api.get(`/product-categories/company/${companyId}`);

export const createCategory = (data) =>
  api.post("/product-categories", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const updateCategory = (id, data) =>
  api.put(`/product-categories/${id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });


export const deleteCategory = (id, payload) =>
  api.put(`/product-categories/delete/${id}`, payload);